import { render } from "./MaterialAvatar.vue?vue&type=template&id=50cb96f6&scoped=true"
import script from "./MaterialAvatar.vue?vue&type=script&lang=js"
export * from "./MaterialAvatar.vue?vue&type=script&lang=js"

import "./MaterialAvatar.vue?vue&type=style&index=0&id=50cb96f6&scoped=true&lang=scss"

import exportComponent from "/working_dir/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50cb96f6"]])

export default __exports__